<template>
    <div class="qr-container">
        <!-- Icono de persona SVG -->
        <div class="icono-persona">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="#1976d2">
                <circle cx="12" cy="8" r="4" />
                <path d="M12 14c-5 0-8 2.5-8 4v2h16v-2c0-1.5-3-4-8-4z" />
            </svg>
        </div>
        <!-- QR con datos -->
        <qrcode-vue :value="qrTexto" :size="160" level="M" />
        <!-- Información personal debajo -->
        <div class="info-personal">
            <div><strong>Nombre:</strong> {{ nombre }}</div>
            <div><strong>Cédula:</strong> {{ cedula }}</div>
            <div><strong>Correo:</strong> {{ correo }}</div>
        </div>
    </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
    components: { QrcodeVue },
    data() {
        return {
            nombre: "Juan Pérez",
            cedula: "12345678",
            correo: "juan.perez@email.com"
        };
    },
    computed: {
        qrTexto() {
            // Emoji de persona al inicio
            return `👤\nNombre: ${this.nombre}\nCédula: ${this.cedula}\nCorreo: ${this.correo}`;
        }
    }
};
</script>

<style scoped>
.qr-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 30px;
}

.icono-persona {
    margin-bottom: 8px;
}

.info-personal {
    margin-top: 10px;
    text-align: center;
    font-size: 1.1em;
    color: #333;
}
</style>